const parseErrorBody = async (res: Response): Promise<string> => {
  try {
    const contentType = res.headers.get('content-type') ?? ''

    if (contentType.includes('application/json')) {
      const json = await res.json() as { error?: string, message?: string }

      return json.error ?? json.message ?? `Richiesta fallita: ${res.status}`
    }

    const text = await res.text()

    return text || `Richiesta fallita: ${res.status}`
  } catch {
    return `Richiesta fallita: ${res.status}`
  }
}

const parseBody = <T>(res: Response): Promise<T | undefined> => {
  if (res.status === 204) {
    return Promise.resolve(undefined)
  }

  const contentType = res.headers.get('content-type') ?? ''

  if (!contentType.includes('application/json')) {
    return Promise.resolve(undefined)
  }

  return res.json() as Promise<T>
}

/**
 * Chiamata generica all'API. Solleva un Error sulle risposte non 2xx, con il
 * messaggio ricavato dal corpo JSON (`{ error }`) o dal testo. Sulle 2xx
 * restituisce il corpo JSON, oppure `undefined` per 204 e risposte non JSON.
 *
 * Il tipo T va indicato esplicitamente quando ci si aspetta un corpo.
 */
export const apiFetch = async <T = void>(
  path: string,
  init: RequestInit = {},
): Promise<T> => {
  const res = await fetch(path, {
    credentials: 'include',
    ...init,
  })

  if (!res.ok) {
    throw new Error(await parseErrorBody(res))
  }

  return (await parseBody<T>(res)) as T
}
